import api from './api';

export interface PublicQuiz {
  _id: string;
  title: string;
  description: string;
  type: 'deck-based' | 'custom';
  questionsCount: number;
  tags: string[];
  attemptsCount: number;
  averageScore: number;
  bestScore: number;
  createdAt: string;
  updatedAt: string;
  creatorName: string;
  creatorEmail: string;
}

export interface QuizSearchQuery {
  q?: string;
  tags?: string;
  page?: number;
  limit?: number;
}

export interface QuizSearchResponse {
  quizzes: PublicQuiz[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

class PublicQuizService {
  async searchQuizzes(query: QuizSearchQuery): Promise<QuizSearchResponse> {
    const params = new URLSearchParams();
    
    params.append('type', 'quizzes');
    if (query.q) params.append('q', query.q);
    if (query.tags) params.append('tags', query.tags);
    if (query.page) params.append('page', query.page.toString());
    if (query.limit) params.append('limit', query.limit.toString());

    const response = await api.get(`/public/search?${params.toString()}`);
    return response.data;
  }

  async getQuizById(id: string): Promise<any> {
    const response = await api.get(`/public/quizzes/${id}`);
    return response.data;
  }
}

export default new PublicQuizService();